import React from "react";
import "./BharatBuildcon.css";

const BharatBuildcon = () => {
  return (
    <div className="BharatBuildcon">
      <div className="bbc-container">

        {/* Header Image */}
        <div className="bs-header">
          <img
            src="https://res.cloudinary.com/dxvbzgdgw/image/upload/v1779085874/New_Bharat_Buildcon_2026-IIFA_page-0001_jhkm5s.jpg"
            alt="Bharat Buildcon"
            className="bs-logo"
          />
        </div>

        <div className="bbc-card">

          {/* Title */}
          <h1 className="bbc-title">
            BHARAT BUILDCON
          </h1>

          <p className="bbc-subtitle">
            International exhibition for building materials
          </p>

          {/* Date & Location */}
          <div className="bbc-tags">
            <span className="bbc-tag green">
              📅 18 19 20 21 JUNE, 2026
            </span>
            <span className="bbc-tag blue">
              📍 YASHOBHOOMI, NEW DELHI - INDIA
            </span>
          </div>

          <div className="bbc-tags">
            <a
              href="https://cloud.hoverbusinessservices.com/aiifa/broucher/new-bharat-buildcon-2026-IIFA.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="bbc-brochure-link"
            >
              Download Brochure
            </a>
            <a
              href="https://cloud.hoverbusinessservices.com/aiifa/broucher/AIIFA.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="bbc-brochure-link"
            >
              Download Flyer for Aiifa Members
            </a>
          </div>
          {/* Quote */}
          <div className="bbc-section">
            <p>
              “With each new project and initiative, India is taking giant strides towards realizing its full potential and emerging as a global leader in building infrastructure that is vibrant, inclusive, and resilient.”
            </p>
            <p><strong>Shri Narendra Modi</strong></p>
            <p>Hon’ble Prime Minister of India</p>
          </div>


          {/* Why Exhibit */}
          <div className="bbc-section">
            <h3 className="bbc-section-title">Why Exhibit?</h3>

            <div className="bbc-grid">
              <div className="bbc-card-item">
                <p>
                  The first exhibition of building material industry supported by the Ministry of Commerce & Industry and Ministry of Housing & Urban Affairs, Government of India.
                </p>
              </div>

              <div className="bbc-card-item">
                <p>
                  A national platform designed to showcase India’s manufacturing strength and represent the country on the global stage, aligned with the vision of One Nation, One Expo.
                </p>
              </div>

              <div className="bbc-card-item">
                <p>
                  Direct access to 1000+ international buyers from 100+ countries.
                </p>
              </div>

              <div className="bbc-card-item">
                <p>
                  Strong presence of 30000+ domestic buyers including dealers, distributors, traders, developers, builders, architects, interior designers & Government Procurement Department.
                </p>
              </div>

              <div className="bbc-card-item">
                <p>
                  Participate in conferences and knowledge sharing seminars to gain insights of new trends, government policies, and future business opportunities.
                </p>
              </div>
            </div>
          </div>

          {/* Venue */}
          <div className="bbc-section">
            <h3 className="bbc-section-title">YASHOBHOOMI (IICC)</h3>

            <div className="bbc-grid">
              <div className="bbc-card-item">
                <p>( Asia’s largest & world’s third largest – convention centre )</p>
              </div>

              <div className="bbc-card-item">
                <p>Spanning over 890,000 square meters</p>
              </div>

              <div className="bbc-card-item">
                <p>Total indoor exhibition and convention area of 300,000 square meters</p>
              </div>

              <div className="bbc-card-item">
                <p>One of the largest MICE (Meetings, Incentives, Conferences, and Exhibitions) destinations in Asia.</p>
              </div>

              <div className="bbc-card-item">
                <p>10 km from Indira Gandhi International Airport</p>
              </div>

              <div className="bbc-card-item">
                <p>Direct metro access from inside the venue (Airport Express & Blue Line)</p>
              </div>

              <div className="bbc-card-item">
                <p>3,600 rooms in nearby Aerocity</p>
              </div>

              <div className="bbc-card-item">
                <p>Parking capacity for 2,900 vehicles</p>
              </div>

              <div className="bbc-card-item">
                <p>Easy connectivity to key hubs: Gurgaon, Diplomatic Enclave, and Dwarka Expressway</p>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="bbc-section">
            <h3 className="bbc-section-title">What to Expect in 2026 ?</h3>

            <div className="bbc-grid">
              <div className="bbc-card-item">
                <p>30,000+ Domestic visitors</p>
              </div>

              <div className="bbc-card-item">
                <p>1000+ International buyers from 100+ Countries</p>
              </div>

              <div className="bbc-card-item">
                <p>350+ Exhibitors from across India & Globe</p>
              </div>
            </div>
          </div>

          {/* Visitor Profile */}
          <div className="bbc-section">
            <h3 className="bbc-section-title">Visitor’s Profile</h3>

            <div className="bbc-grid">
              <div className="bbc-card-item"><p>Dealers</p></div>
              <div className="bbc-card-item"><p>Distributors</p></div>
              <div className="bbc-card-item"><p>Architects</p></div>
              <div className="bbc-card-item"><p>Hoteliers</p></div>
              <div className="bbc-card-item"><p>Large retailers</p></div>
              <div className="bbc-card-item"><p>Project management companies</p></div>
              <div className="bbc-card-item"><p>Merchant Exporter</p></div>
              <div className="bbc-card-item"><p>Interior decorators</p></div>
              <div className="bbc-card-item"><p>Builders</p></div>
              <div className="bbc-card-item"><p>Real estate companies</p></div>
              <div className="bbc-card-item"><p>Contractors</p></div>
              <div className="bbc-card-item"><p>Government procurement department</p></div>
              <div className="bbc-card-item"><p>Importers</p></div>
              <div className="bbc-card-item"><p>Distributors</p></div>
              <div className="bbc-card-item"><p>Agents/ Representatives</p></div>
              <div className="bbc-card-item"><p>Traders</p></div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default BharatBuildcon;




